import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { toggleFavoriteDashboardState, selectFavoriteDashboards } from '@store';
import { usePermissions } from '@hooks';

import { NAVIGATION_SECTION } from 'layouts/DrawerLayout/Menu/constants';
import getRoutes from 'layouts/DrawerLayout/getRoutes';

const useFavoriteDashboards = () => {
  const dispatch = useDispatch();

  const { pathname } = useRouter();

  const { findEntity } = usePermissions();

  const favoriteDashboards = useSelector(selectFavoriteDashboards);

  const routeOptions = useMemo(() => {
    const routes = getRoutes(findEntity) || [];
    return routes
      .filter((r) => r.key !== NAVIGATION_SECTION.myHub.value)
      .flatMap((r) => r.options || [])
      .filter(Boolean);
  }, [findEntity]);

  const isFavoriteDashboard = useCallback(
    (url) => (favoriteDashboards || []).some((f) => f.url === url),
    [favoriteDashboards]
  );

  const isFavoriteApplicable = useMemo(
    () => !!routeOptions.find((rOpt) => rOpt.url === pathname),

    [routeOptions, pathname]
  );

  const toggleDashboard = useCallback(
    (url) => {
      const favoriteRoute = routeOptions.find((r) => r.url === url);
      if (!favoriteRoute) {
        return;
      }

      dispatch(toggleFavoriteDashboardState({ ...favoriteRoute }));
    },
    [routeOptions, dispatch]
  );

  return {
    isFavoriteApplicable,
    favoriteDashboards,
    isFavoriteDashboard,
    toggleDashboard,
  };
};

export { useFavoriteDashboards };
